import React from "react";
import { Box, Tooltip, Button } from "@material-ui/core";

import { Check, Close, Description, Replay } from "@material-ui/icons";

export const exportTransformColumn = (
  expDisplayColumns: any,
  getWeBOCFileDetails: any,
  weBOCFileGenerateHandler: any,
  formik: any,
  setExpDisplayColumns: any
) => {
  const transformedColumns: any = expDisplayColumns.map((column: any) =>
    column.accessorKey === "isOPIAReceived"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <>
                <Box>
                  <Tooltip title={row.original?.isOPIAReceived ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isOPIAReceived ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isOPIAReceived ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>

                  {row.original?.isOPIAReceived && (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "OPIA",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </>
            );
          },
        }
      : column.accessorKey === "isOGIESent"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <>
                <Box>
                  <Tooltip title={row.original?.isOGIESent ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isOGIESent ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isOGIESent ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isOGIESent ? (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "OGIE",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  ) : (
                    row.original.gatePassId !== 0 && (
                      <Tooltip title="Generate">
                        <Button
                          style={{
                            minWidth: "30px",
                            padding: "4px",
                            color: "#0d99ff",
                          }}
                          onClick={() =>
                            weBOCFileGenerateHandler(
                              row.original.gatePassId,
                              row.original.webocVehicleNumber,
                              "OGIE",
                              formik.values.processType,
                              formik.values.gdNumber
                            )
                          }
                        >
                          <Replay />
                        </Button>
                      </Tooltip>
                    )
                  )}
                </Box>
              </>
            );
          },
        }
      : column.accessorKey === "isOGDEReceived"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <>
                <Box>
                  <Tooltip title={row.original?.isOGDEReceived ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isOGDEReceived ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isOGDEReceived ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isOGDEReceived && (
                    <Tooltip title={"File"}>
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "OGDE",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </>
            );
          },
        }
      : column.accessorKey === "isOEHCReceived"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <>
                <Box>
                  <Tooltip title={row.original?.isOEHCReceived ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isOEHCReceived ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isOEHCReceived ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isOEHCReceived && (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "OEHC",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </>
            );
          },
        }
      : column.accessorKey === "isOSRCsent"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <>
                <Box>
                  <Tooltip title={row.original?.isOSRCsent ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isOSRCsent ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isOSRCsent ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isOSRCsent ? (
                    <Tooltip title={"File"}>
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "OSRC",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  ) : (
                    row.original.gatePassId !== 0 && (
                      <Tooltip title="Generate">
                        <Button
                          style={{
                            minWidth: "30px",
                            padding: "4px",
                            color: "#0d99ff",
                          }}
                          onClick={() =>
                            weBOCFileGenerateHandler(
                              row.original.gatePassId,
                              row.original.webocVehicleNumber,
                              "OSRC",
                              formik.values.processType,
                              formik.values.gdNumber
                            )
                          }
                        >
                          <Replay />
                        </Button>
                      </Tooltip>
                    )
                  )}
                </Box>
              </>
            );
          },
        }
      : column.accessorKey === "isOECMReceived"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <>
                <Box>
                  <Tooltip title={row.original?.isOECMReceived ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isOECMReceived ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isOECMReceived ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isOECMReceived && (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "OECM",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </>
            );
          },
        }
      : column.accessorKey === "isOCRLReceived"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <>
                <Box>
                  <Tooltip title={row.original?.isOCRLReceived ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isOCRLReceived ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isOCRLReceived ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isOCRLReceived && (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "OCRL",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </>
            );
          },
        }
      : column.accessorKey === "isOGTESent"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <>
                <Box>
                  <Tooltip title={row.original?.isOGTESent ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isOGTESent ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isOGTESent ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isOGTESent ? (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "OGTE",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  ) : (
                    row.original.gatePassId !== 0 && (
                      <Tooltip title="Generate">
                        <Button
                          style={{
                            minWidth: "30px",
                            padding: "4px",
                            color: "#0d99ff",
                          }}
                          onClick={() =>
                            weBOCFileGenerateHandler(
                              row.original.gatePassId,
                              row.original.webocVehicleNumber,
                              "OGTE",
                              formik.values.processType,
                              formik.values.gdNumber
                            )
                          }
                        >
                          <Replay />
                        </Button>
                      </Tooltip>
                    )
                  )}
                </Box>
              </>
            );
          },
        }
      : column
  );
  setExpDisplayColumns(transformedColumns);
  return transformedColumns;
};
